import { Link } from "react-router-dom";
import { MousePointerClick, CalendarCheck, MailCheck, Video, Building2 } from "lucide-react";

const STEPS = [
  { icon: MousePointerClick, title: "Pick visit type", text: "Clinic visit or video call from home." },
  { icon: CalendarCheck, title: "Choose a slot", text: "See real free times, Mon–Sat." },
  { icon: MailCheck, title: "Get confirmation", text: "Instant reference number and email updates." },
];

export const HowItWorks = () => (
  <section className="bg-[#0f3b3a] py-24 text-white" data-testid="how-it-works-section">
    <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-2 lg:px-8">
      <div>
        <span className="text-xs font-bold uppercase tracking-widest text-[#f5b82e]">Booking made easy</span>
        <h2 className="mt-3 text-3xl font-bold tracking-tight text-white sm:text-4xl">Three taps to a happy check-up</h2>
        <div className="mt-10 space-y-6">
          {STEPS.map((s, i) => (
            <div key={s.title} className="flex gap-5">
              <div className="font-display flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#f5b82e] text-xl font-bold text-slate-900">{i + 1}</div>
              <div><p className="font-display text-lg font-semibold text-white">{s.title}</p><p className="text-sm text-teal-100/80">{s.text}</p></div>
            </div>
          ))}
        </div>
      </div>
      <div className="grid gap-5 sm:grid-cols-2">
        <Link to="/book?type=clinic" data-testid="how-book-clinic-card"
          className="btn-pop group rounded-[2rem] bg-white p-8 text-slate-800">
          <Building2 className="h-10 w-10 text-[#ff6b6b] transition-transform group-hover:scale-110" />
          <p className="font-display mt-6 text-2xl font-semibold">In-clinic visit</p>
          <p className="mt-2 text-sm text-slate-500">Check-ups, cleaning and treatments in our playful Malad West clinic.</p>
          <p className="mt-6 text-sm font-bold text-teal-700">Book a visit →</p>
        </Link>
        <Link to="/book?type=online" data-testid="how-book-online-card"
          className="btn-pop group rounded-[2rem] bg-[#38bdf8] p-8 text-slate-900 sm:translate-y-8">
          <Video className="h-10 w-10 transition-transform group-hover:scale-110" />
          <p className="font-display mt-6 text-2xl font-semibold">Online consult</p>
          <p className="mt-2 text-sm text-slate-800">Quick video advice for toothaches, injuries, habits or second opinions.</p>
          <p className="mt-6 text-sm font-bold">Start online →</p>
        </Link>
      </div>
    </div>
  </section>
);
